import { render, staticRenderFns } from "./indexinforlist.html?vue&type=template&id=4016a704&scoped=true&"
import script from "./indexinforlist.js?vue&type=script&lang=js&"
export * from "./indexinforlist.js?vue&type=script&lang=js&"
import style0 from "./indexinforlist.sass?vue&type=style&index=0&id=4016a704&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4016a704",
  null
  
)

component.options.__file = "indexinforlist.vue"
export default component.exports